export class ServerWindow {};
